<template>
  <div>
    <b-form @submit.prevent="saveSettings" v-if="!fetching">
      <b-row class="manager-oninvoice-setting">
        <b-col sm="12" lg="12" style="padding: 0" class="oninvoice-setting">
          <b-card class="mb-4 oninvoice-setting-card">
            <b-card-body class="oninvoice-setting-form-card-body p-0">
              <div class="container oninvoice-setting-container">
                <div class="row mb-3">
                  <div class="col-md-12">
                    <span style="font-weight: semi-bold; font-size: 20pt">{{
                      __('Oninvoice Settings')
                    }}</span>
                  </div>
                </div>
                <hr class="mt-1" />
                <div class="col-md-12 oninvoice-setting-form">
                  <b-row>
                    <b-col sm="12">
                      <b-form-group :label="__('Activate')">
                        <b-form-checkbox v-model="setting.enabled"></b-form-checkbox>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-form-group>
                    <b-row class="mb-1 mt-3">
                      <div class="col-md-2">
                        <label class="form-title d-inline-block w-100 pt-2">
                          {{ __('API Token') }}
                          <span class="required">*</span>
                        </label>
                      </div>
                      <div class="col-md-10 col-sm-12">
                        <b-form-input
                          class="form-control"
                          v-model="setting.settings.apiToken"
                          :placeholder="__('Enter Oninvoice API token...')"
                        ></b-form-input>
                      </div>
                    </b-row>
                  </b-form-group>

                  <b-row>
                    <b-col sm="12" class="text-center mt-5 mb-3">
                      <b-button type="submit" variant="primary" :disabled="processing">
                        <b-spinner variant="light" small v-if="processing"></b-spinner>
                        <span>{{ __('Save') }}</span>
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-alert :variant="success ? 'success' : 'danger'" v-if="message" show>
                    {{ message }}
                  </b-alert>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fetching: false,
      success: false,
      message: '',
      setting: {
        settings: {},
      },
      processing: false,
    };
  },

  beforeMount() {
    this.fetchSetting();
  },

  methods: {
    fetchSetting() {
      this.fetching = true;
      axios
        .get('/api/integrations/showByName/oninvoice')
        .then(({ data: { data: setting } }) => {
          this.setting = { ...setting, enabled: setting.enabled == 1 };
        })
        .catch((error) => {
          console.log(error);
          alert(error);
        })
        .finally(() => {
          this.fetching = false;
        });
    },

    saveSettings() {
      this.processing = true;

      axios
        .get('/sanctum/csrf-cookie')
        .then(() => {
          let postData = {
            _method: 'put',
            enabled: this.setting.enabled == 1,
            ...this.setting,
          };

          axios
            .post(`/api/integrations/${this.setting.id}`, postData)
            .then(({ data: { message, success } }) => {
              this.message = message;
              this.success = success;
            })
            .catch((error) => {
              console.log(error);
              alert(error);
            })
            .finally(() => {});
        })
        .catch((error) => {
          console.log(error);
          alert(error);
        })
        .finally(() => {
          this.processing = false;
        });
    },
  },
};
</script>

<style>

.layout-sidebar-large .main-content-wrap {
  background-image: url('@/assets/images/form/form-bg-orange.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: center;
}

.oninvoice-setting-container {
  padding: 0;
}

@media only screen and (max-width: 360px) {
  .oninvoice-setting-card-body,
  .oninvoice-setting-container {
    padding: 0;
  }

  .oninvoice-setting-container .form-title {
    padding-right: 0;
  }

  .oninvoice-setting-card {
    width: 285px;
  }

  .oninvoice-setting-form {
    padding: 0;
  }

  .layout-sidebar-large .main-content-wrap {
    padding-right: 10px;
  }
}

@media only screen and (max-width: 600px) {
  .manager-oninvoice-setting {
    width: 113% !important;
  }
}
</style>